import axios from 'axios'

/**
 * @param {string} attemptId
 * @returns
 */
export const getChallengesAIEvaluations = async (attemptId) => {
  const response = await axios.get(`ai-evaluations`, {
    params: { attemptId }
  })
  return response
}

/**
 * @param {string} attemptId
 * @returns
 */
export const getChallengesOfLinearityScore = async (attemptId) => {
  const response = await axios.get(`attempt-results/linearity-score`, {
    params: { attemptId }
  })
  return response
}
